import { XML_GetScale } from "./XML_GetScale";

export function XML_AdjustLineWidth(weight, drawElement, layer) {
  var scale = XML_GetScale(drawElement, layer); // drawElement["scale"];
  if (scale != null) weight *= scale;
  return weight;
}
